import CertificationLogo from 'components/common/CertificationLogo/CertificationLogo';
import { CategoryDetail } from 'types/Search';
import './SearchCertificationList.scss';
import { getNumberOfIcons } from './awardsHelper';
import { Tooltip } from '@mui/material';

interface SearchCertificationsProps {
  certifications: CategoryDetail[];
  awardsCount?: number;
}

const SearchCertifications = ({
  certifications,
  awardsCount
}: SearchCertificationsProps) => {
  const numberOfIconsToShow = getNumberOfIcons(
    certifications.length,
    awardsCount ?? 0,
    'CERTIFICATION'
  );
  const visibleCertifications = certifications.slice(0, numberOfIconsToShow);
  const hiddeCertifications = certifications.slice(numberOfIconsToShow);
  return (
    <div className="search-certification">
      {certifications && certifications.length > 0 && (
        <>
          {certifications.length <= 2 ? (
            certifications.map((certification: CategoryDetail) => (
              <CertificationLogo
                key={certification.value}
                certificationValue={certification.value}
              />
            ))
          ) : (
            <>
              {visibleCertifications.map(certification => (
                <CertificationLogo
                  key={certification.value}
                  certificationValue={certification.value}
                />
              ))}

              {hiddeCertifications.length > 0 && (
                <Tooltip
                  title={hiddeCertifications
                    .map(certification => certification.value)
                    .join(', ')}
                >
                  <span className="search-certification-container search-certification-container--plus">
                    <div className="search-certification-image search-certification-image--plus">
                      +{hiddeCertifications.length}
                    </div>
                  </span>
                </Tooltip>
              )}
            </>
          )}
        </>
      )}
    </div>
  );
};

export default SearchCertifications;
